module.exports = __webpack_public_path__ + "media/images/pc/staffs/mv_planner@3x-a830f8057383b0b34c055914c74972d4.webp";